<script setup lang="ts">
import { computed } from 'vue'

import { statusChipCva, StatusChipProps } from '.'
import { FontAwesomeIconProps, IconName } from '../../Icon/fontAwesome'
import Icon from '../../Icon/Icon.vue'

type Props = {
  size?: StatusChipProps['size']
  variant?: StatusChipProps['variant']
  rounded?: StatusChipProps['rounded']
}
const props = defineProps<Props>()

// computed
const iconSize = computed(() => props.size as FontAwesomeIconProps['size'])
const icon = computed<IconName>(() => {
  switch (props.variant) {
    case 'success':
      return 'check'
    case 'error':
      return 'circle-exclamation'
    default:
      return 'circle-info'
  }
})
</script>

<template>
  <div :class="statusChipCva({ size, variant, rounded })">
    <Icon
      :icon
      :size="iconSize"
    />
    <slot></slot>
  </div>
</template>
